// The numbers behind the hero background (kept free of React and the canvas so they can be tested).

export const MAX_LINK = 150;           // how far apart two dots may be and still be joined by a line (px)
export const MOUSE_RADIUS = 160;       // how far the pointer reaches (px)

// Roughly one dot per 9000 px² - fewer on a phone, never more than `max` so a wide screen stays light.
export function particleCount(width, height, { density = 1 / 9000, min = 14, max = 90 } = {}) {
  const raw = Math.round(Math.max(0, width) * Math.max(0, height) * density);
  return Math.min(max, Math.max(min, raw));
}

export function makeParticles(count, width, height, rand = Math.random) {
  return Array.from({ length: count }, () => {
    const angle = rand() * Math.PI * 2;
    const speed = 6 + rand() * 14;                                   // px per second
    return {
      x: rand() * width,
      y: rand() * height,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      r: 1.2 + rand() * 1.8,
      hue: rand() < 0.22 ? "violet" : "cyan",
    };
  });
}

// Move a dot; it leaves one edge and comes back in from the other.
export function stepParticle(p, dt, width, height) {
  const pad = 20;
  let x = p.x + p.vx * dt;
  let y = p.y + p.vy * dt;
  if (x < -pad) x = width + pad;
  else if (x > width + pad) x = -pad;
  if (y < -pad) y = height + pad;
  else if (y > height + pad) y = -pad;
  return { ...p, x, y };
}

// 0 when the dots are too far apart to join, up to ~0.5 when they touch.
export function linkAlpha(distance, max = MAX_LINK) {
  if (!(distance >= 0) || distance >= max) return 0;
  return Math.pow(1 - distance / max, 1.6) * 0.5;
}

// A gentle push away from the pointer; nothing outside its reach or when there is no pointer.
export function pointerPush(p, pointer, radius = MOUSE_RADIUS, strength = 40) {
  if (!pointer) return { dx: 0, dy: 0 };
  const dx = p.x - pointer.x;
  const dy = p.y - pointer.y;
  const dist = Math.hypot(dx, dy);
  if (dist >= radius || dist === 0) return { dx: 0, dy: 0 };
  const force = (1 - dist / radius) * strength;
  return { dx: (dx / dist) * force, dy: (dy / dist) * force };
}

// The biggest pixel ratio worth drawing at: sharp on a retina screen, but never a huge canvas.
export function drawScale(devicePixelRatio) {
  const dpr = Number(devicePixelRatio) || 1;
  return Math.min(2, Math.max(1, dpr));
}
